var _circle, _circle2, _path, _path2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWincoin = function SvgWincoin(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "33px",
    height: "33px",
    viewBox: "-7.017 -7.017 33 33",
    enableBackground: "new -7.017 -7.017 33 33",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Icon-winners-coin",
    transform: "translate(-0.863 -0.181)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_531_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.7507,
    y1: 4.8119,
    x2: 12.1527,
    y2: 3.8119,
    gradientTransform: "matrix(18.968 0 0 -18.968 -216.3681 91.4827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2A11D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    style: {
      stopColor: "#D1A806"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    style: {
      stopColor: "#FFF600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    style: {
      stopColor: "#F0E914"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#F09814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    style: {
      stopColor: "#FFFA70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F07B14"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    fill: "url(#Ellipse_531_1_)",
    cx: 10.347,
    cy: 9.665,
    r: 9.484
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ellipse_271_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.5144,
    y1: 2.7752,
    x2: 13.5144,
    y2: 1.7752,
    gradientTransform: "matrix(17.242 0 0 -17.242 -222.6778 48.9084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#453284"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#132CA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#F03914"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03914"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_271",
    fill: "url(#Ellipse_271_1_)",
    cx: 10.346,
    cy: 9.664,
    r: 8.621
  })), /*#__PURE__*/React.createElement("g", {
    id: "w",
    transform: "translate(4.026 6.925) rotate(-16)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17994",
    fill: "#853B00",
    d: "M12.125,3.092C11.423,4.11,10.681,5.1,9.898,6.061c-0.499,0.615-1.02,1.232-1.561,1.851 c-0.8,0.912-1.029,1.023-2.017,0.763L5.329,8.414c-0.761-0.2-0.889-0.416-0.7-1.163l0.589-2.353l-0.013,0L3.931,6.672 c-0.744,1.039-0.874,1.144-1.952,0.86l-1.215-0.32C0.289,7.087,0.155,6.667,0.301,5.773C0.409,5.114,0.532,4.429,0.669,3.72 c0.223-1.155,0.506-2.296,0.847-3.422L4.105,0.98c-0.24,0.706-0.453,1.379-0.64,2.019c-0.187,0.64-0.357,1.286-0.511,1.939 l0.013,0.001l2.012-2.818c0.508-0.713,0.618-0.748,1.5-0.515l0.678,0.178c0.832,0.219,0.965,0.329,0.654,1.509L7.13,6.038l0.013,0 c0.475-0.632,0.904-1.24,1.287-1.822c0.383-0.582,0.761-1.182,1.132-1.8L12.125,3.092z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_17995_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3361,
    y1: -32.2162,
    x2: 17.2011,
    y2: -32.3532,
    gradientTransform: "matrix(11.4208 2.3425 3.2749 -8.1692 -80.9651 -297.6517)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFECCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    style: {
      stopColor: "#FFF9EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF0D5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17995",
    fill: "url(#Path_17995_1_)",
    d: "M11.881,2.792c-0.703,1.018-1.445,2.009-2.227,2.97 c-0.5,0.615-1.021,1.232-1.561,1.851c-0.8,0.913-1.029,1.024-2.018,0.763L5.083,8.115c-0.761-0.2-0.888-0.417-0.699-1.164 L4.973,4.6l-0.013,0L3.686,6.373c-0.744,1.038-0.873,1.144-1.952,0.86l-1.215-0.32C0.044,6.788-0.09,6.367,0.056,5.475 c0.108-0.66,0.231-1.344,0.368-2.054C0.646,2.267,0.929,1.125,1.27,0l2.59,0.681C3.62,1.387,3.407,2.06,3.22,2.7 C3.033,3.34,2.863,3.987,2.709,4.64l0.013,0l2.012-2.818c0.508-0.713,0.618-0.748,1.5-0.515l0.678,0.178 c0.832,0.219,0.965,0.329,0.653,1.509l-0.68,2.744l0.013,0.001c0.475-0.635,0.903-1.244,1.287-1.825 c0.384-0.582,0.762-1.182,1.132-1.8L11.881,2.792z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWincoin, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };